import { render, staticRenderFns } from "./MatchScoringPage.vue?vue&type=template&id=a542b80e&"
import script from "./MatchScoringPage.vue?vue&type=script&lang=js&"
export * from "./MatchScoringPage.vue?vue&type=script&lang=js&"
import style0 from "./MatchScoringPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports